import { Navigate } from 'react-router-dom';

import SettingsLayout from './components/SettingsLayout';
import ProfileSettingsPage from './pages/ProfileSettingsPage';
import WorkspaceEmailTemplatesPage from './pages/WorkspaceEmailTemplatesPage';
import WorkspaceSettingsPage from './pages/WorkspaceSettingsPage';
import WorkspaceUsersPage from './pages/WorkspaceUsersPage';

export const settingsRoutes = {
  path: 'settings',
  element: <SettingsLayout />,
  children: [
    { index: true, element: <Navigate to="/settings/profile" replace /> },
    { path: 'profile', element: <ProfileSettingsPage /> },
    { path: 'workspaces', element: <WorkspaceSettingsPage /> },
    { path: 'workspace/users', element: <WorkspaceUsersPage /> },
    {
      path: 'workspace/email-templates',
      element: <WorkspaceEmailTemplatesPage />,
    },
  ],
};
